<template>
    <div>
        <v-app-bar dense min-height="48px" max-height="48px" color="primary" flat app>
            <v-app-bar-nav-icon color="white" @click="mini_variant=!mini_variant"></v-app-bar-nav-icon>
            <v-spacer></v-spacer>
            <v-btn x-small text color="white" @click="logout()" elevation="true">
                <span>Sign Out</span>
                <v-icon>mdi-logout</v-icon>
            </v-btn>
        </v-app-bar>
        
        <nav>
                <v-navigation-drawer app :miniVariant="mini_variant">
                <v-list>
                  <v-list-item>
                      <v-list-item-content>
                      <v-list-item-title class="title text-uppercase d-flex child-flex">
                          <v-img contain src="/logo.png" align="center"></v-img>
                          <span class="sub-title">Panel</span>
                      </v-list-item-title>
                      <!-- <v-list-item-subtitle>
                          Back Office Printyuk
                      </v-list-item-subtitle> -->
                      </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                </v-list>
                <v-list dense>
                  <div v-for="item in items" :key="item.title" :to="item.to">
                    <v-list-group v-if="item.parent" :prepend-icon="item.icon">
                      <template v-slot:activator nav dense link>
                        <v-list-item-content>
                          <v-list-item-title class="font-weight-strong">{{item.title}}</v-list-item-title>
                        </v-list-item-content>
                      </template>
                      <v-list-item v-for="child in item.child" :key="child.title" dense nav link :to="child.to">
                        <v-list-item-icon>
                          <v-icon></v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title class="font-weight-light">{{child.title}}</v-list-item-title></v-list-item-content>
                      </v-list-item>
                    </v-list-group>
                    
                    <v-list-item v-else nav dense link :to="item.to">
                        <v-list-item-icon><v-icon>{{item.icon}}</v-icon></v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-strong">{{item.title}}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </div>
                </v-list>
  
                </v-navigation-drawer>
        </nav>
    </div>
</template>

<script>
  /* eslint-disable */
  export default {
    data () {
      return {
        items: [
          { title: 'Dashboard', icon: 'mdi-view-dashboard', to: '/dashboard', parent:false },
          { title: 'Users', icon: 'mdi-account', to: '/users', parent:false },
          { title: 'Catalog', icon: 'mdi-book', to: '/catalog', parent:true,
            child:[
              {title: 'Category', icon: '', to: '/category', parent:true,},
              {title: 'Attribute', icon: '', to: '/attributes', parent:true,},
              {title: 'Product', icon: '', to: '/products', parent:true,},
              {title: 'Vendor', icon: '', to: '/vendor', parent:true,}
            ]
          },
          { title: 'Settings', icon: 'mdi-settings', to: '/setting', parent:true,
            child:[
              {title: 'Locales', icon: '', to: '/locales', parent:true,},
            ]
          }
        ],
        mini_variant:false,
      }
    },
    methods:{
      logout(){
        this.$store.dispatch('LOGOUT')
        .then(response=>{
            if(response.data.success){
              this.$cookies.remove('jwt');
              this.$router.push('/');
            }
        })
        .catch(error=>{
          console.log(error);
        })
      }
    }
  }
</script>